<div class="exception-body notfound-page">

    <div class="scroll-content no-padding-right">
        <div class="exception-type">
            <img src="../../../../assets/layout/images/404.svg">
        </div>

        <div class="card exception-panel">
            <em class="material-icons">&#xE001;</em>
            <h1>Page Not Found</h1>
            <div class="exception-detail">The resource you are looking for does not exist.</div>
            <a routerLink="/" class="ui-button secondary">
                <span class="ui-button-text">Homepage</span>
            </a>
        </div>
    </div>
</div>
